exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-background[data-v-afc3fd40]{width:100%;min-height:100vh;padding:0;margin:0;display:flex;flex-direction:column}", ""]);

// exports
